import barba from "@barba/core";
import { init as nl__init } from "./init.js";
import { gsap } from 'gsap';
import { smoothkiller, smoothGoTo, init as lenisInit  } from "./parts/lenis";
import { killsliders  } from "./parts/slick";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const init = async () => {
    const hasBarbaWrapper = document.querySelector('[data-barba="container"]');

    if (hasBarbaWrapper) {
        barba.init({
            debug: false,
            timeout: 18000,
            sync: true,
            preventRunning: true,
            prevent: ({ el, event }) => {
                if (event.type === "click") {
                    if (el.classList && el.classList.contains("ab-item")) {
                        return true;
                    }
                    if (el.classList && el.classList.contains("prevent")) {
                        return true;
                    }
                    if (
                        el.classList &&
                        el.parentNode.classList.contains("prevent")
                    ) {
                        return true;
                    }
                    if (
                        el.classList &&
                        el.classList.contains("wp-block-button__link")
                    ) {
                        return true;
                    }
                    // prevent the user to reload the page if the location is the same
                    if (el.href === window.location.href) {
                        event.preventDefault();
                        event.stopPropagation();
                        return true;
                    }
                    // if url content exe .pdf return true
                    if (el.href.indexOf(".pdf") > -1) {
                        return true;
                    }
                }
            },
            cacheIgnore: [
                "/favs/",
                "/favoritos/",
                "/favorites/",
                "/en/favorites/",
                "/favoris/",
                "/fr/favoris/",
            ],
            transitions: [
                {
                    name: "default-transition",
                    async leave(data) {
                        await trans_default__page_out(data);
                    },
                    enter() {
                        trans_default__page_in();
                    },
                },
            ],
        });
    }
};

export { init };


history.scrollRestoration = "manual";
var scrollPosY = 0;
barba.hooks.afterLeave((trigger) => {
    smoothkiller();
    ScrollTrigger.killAll();
    killsliders();
});

barba.hooks.beforeEnter((data) => {
    var cf_selector = "div.wpcf7 > form";
    var cf_forms = jQuery(data.next.container).find(cf_selector);
    if (cf_forms.length > 0) {
        cf_forms.each(function () {
            document.dispatchEvent(new CustomEvent('wpcf7DOMContentLoaded', {
                detail: { contactForm: this }
            }));
        });
    }
});

barba.hooks.enter(function (data) {
    if (data.trigger !== "back") {
        scrollPosY = barba.history.current.scroll.y;
    }
});

barba.hooks.leave(function (data) {
    jQuery(".main-search-model").removeClass("opened");
    jQuery("#cursor").removeClass("active");
});

barba.hooks.afterEnter((data) => {
    var vids = document.querySelectorAll("video");
    vids.forEach((vid) => {
        var playPromise = vid.play();
        if (playPromise !== undefined) {
            playPromise.then((_) => {}).catch((error) => {});
        }
    });
});

barba.hooks.after((data) => {
    // Scroll to correct position first
    if (data.trigger !== "back") {
        window.scrollTo(0, 0);
        jQuery(window).scrollTop(0);
    } else {
        window.scrollTo(0, scrollPosY);
        jQuery(window).scrollTop(scrollPosY);
    }

    // Reinitialize Lenis and main functions
    lenisInit(); // Reinitialize Lenis for the new page
    nl__init();

    // Refresh ScrollTrigger immediately after init
    ScrollTrigger.refresh();

    // Also refresh after a short delay to ensure DOM is fully rendered
    setTimeout(() => {
        ScrollTrigger.refresh();
    }, 100);

    var nextHtml = data.next.html;
    var response = nextHtml.replace(
        /(<\/?)body( .+?)?>/gi,
        "$1notbody$2>",
        nextHtml
    );
    var bodyClasses = jQuery(response).filter("notbody").attr("class");
    jQuery("body").attr("class", bodyClasses);

    var video = document.querySelectorAll(".autoplay_video");
    video.forEach(function (video) {
        video.play();
    });

    if (typeof jQuery().relevanssi_live_search == "function") {
        jQuery('input[data-rlvlive="true"]').relevanssi_live_search();
    }
});

function trans_default__page_out() {
    var loader = jQuery(".loader");
    //console.log('page out');
    return new Promise((resolve) => {
        gsap.to(loader, {
            duration: 0.5,
            autoAlpha: 1,
            onComplete: resolve,
        });
    });
}

function trans_default__page_in() {
    var loader = jQuery(".loader");
    //console.log('page in');
    return new Promise((resolve) => {
        gsap.to(loader, {
            duration: 0.5,
            autoAlpha: 0,
            onComplete: resolve,
        });
    });
}
